import { limitNumberToTwoDigits } from '@converge/utils';
import { CoverageErrorDetails } from '../../types';

type Props = {
  raterErrorDetails: CoverageErrorDetails;
  type: string;
  index?: number;
};

export const coverageHasValidationError = ({
  raterErrorDetails,
  index,
  type,
}: Props) => {
  if (!raterErrorDetails) return false;
  const match = raterErrorDetails.filter(
    (error) =>
      typeof error === 'object' &&
      error !== null &&
      type in error &&
      error[type as keyof typeof error] === true &&
      'idx' in error &&
      error.idx === index
  )[0];

  if (!match) return false;
  return index !== undefined;
};

export const getParsedValue = (value?: number | null) =>
  value == null || value === undefined ? null : limitNumberToTwoDigits(value);
